import { render, staticRenderFns } from "./LmMenu.vue?vue&type=template&id=1c21d386&scoped=true&"
import script from "./LmMenu.vue?vue&type=script&lang=js&"
export * from "./LmMenu.vue?vue&type=script&lang=js&"
import style0 from "./LmMenu.vue?vue&type=style&index=0&id=1c21d386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21d386",
  null
  
)

export default component.exports